const mk = {
  // ============================================================
  // COMMON — Заеднички за целата апликација
  // ============================================================
  common: {
    loading: 'Вчитување...',
    error: 'Грешка',
    save: 'Зачувај',
    cancel: 'Откажи',
    delete: 'Избриши',
    edit: 'Измени',
    create: 'Креирај',
    add: 'Додај',
    remove: 'Отстрани',
    close: 'Затвори',
    confirm: 'Потврди',
    apply: 'Примени',
    reset: 'Ресетирај',
    search: 'Пребарај',
    filter: 'Филтрирај',
    clear: 'Исчисти',
    back: 'Назад',
    next: 'Следно',
    previous: 'Претходно',
    submit: 'Поднеси',
    update: 'Ажурирај',
    refresh: 'Освежи',
    export: 'Извези',
    import: 'Увези',
    download: 'Преземи',
    upload: 'Отпреми',
    print: 'Печати',
    copy: 'Копирај',
    yes: 'Да',
    no: 'Не',
    ok: 'OK',
    done: 'Завршено',
    select: 'Избери',
    selectAll: 'Избери сè',
    deselectAll: 'Поништи избор',
    noResults: 'Нема пронајдени резултати',
    noData: 'Нема достапни податоци',
    required: 'Задолжително',
    optional: 'Опционално',
    actions: 'Дејства',
    details: 'Детали',
    overview: 'Преглед',
    summary: 'Резиме',
    total: 'Вкупно',
    all: 'Сите',
    none: 'Ништо',
    name: 'Име',
    type: 'Тип',
    status: 'Статус',
    date: 'Датум',
    time: 'Време',
    description: 'Опис',
    notes: 'Белешки',
    comments: 'Коментари',
    category: 'Категорија',
    priority: 'Приоритет',
    nation: 'Нација',
    country: 'Држава',
    email: 'Е-пошта',
    phone: 'Телефон',
    address: 'Адреса',
    location: 'Локација',
    coordinates: 'Координати',
    latitude: 'Географска ширина',
    longitude: 'Географска должина',
    from: 'Од',
    to: 'До',
    createdAt: 'Креирано',
    updatedAt: 'Ажурирано',
    createdBy: 'Креирал',
    modifiedBy: 'Изменил',
    active: 'Активно',
    inactive: 'Неактивно',
    enabled: 'Овозможено',
    disabled: 'Оневозможено',
    showing: 'Прикажано',
    of: 'од',
    page: 'Страница',
    perPage: 'по страница',
    rows: 'редови',
    items: 'ставки',
    results: 'резултати',
    sortBy: 'Подреди по',
    ascending: 'Растечки',
    descending: 'Опаѓачки',
    viewAll: 'Прикажи сите',
    viewDetails: 'Прикажи детали',
    goBack: 'Врати се',
    learnMore: 'Дознај повеќе',
    seeMore: 'Видете повеќе',
    showMore: 'Прикажи повеќе',
    showLess: 'Прикажи помалку',
    expandAll: 'Прошири сите',
    collapseAll: 'Собери сите',
    copied: 'Копирано!',
    saved: 'Зачувано!',
    deleted: 'Избришано!',
    updated: 'Ажурирано!',
    created: 'Креирано!',
    success: 'Успех',
    warning: 'Предупредување',
    info: 'Информација',
    danger: 'Опасност',
    unknown: 'Непознато',
    notAvailable: 'Н/Д',
    never: 'Никогаш',
    today: 'Денес',
    yesterday: 'Вчера',
    tomorrow: 'Утре',
    now: 'Сега',
    ago: 'пред',
    justNow: 'штотуку',
    minutesAgo: 'пред {{count}}м',
    hoursAgo: 'пред {{count}}ч',
    daysAgo: 'пред {{count}}д',
    monthsAgo: 'пред {{count}}мес',
    id: 'ID',
    version: 'Верзија',
    language: 'Јазик',
    theme: 'Тема',
    darkMode: 'Темен режим',
    lightMode: 'Светол режим',
    failedToLoad: 'Неуспешно вчитување на податоци',
    failedToSave: 'Неуспешно зачувување',
    failedToDelete: 'Неуспешно бришење',
    failedToUpdate: 'Неуспешно ажурирање',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете ова?',
    confirmAction: 'Дали сте сигурни?',
    unsavedChanges: 'Имате незачувани промени. Дали сте сигурни дека сакате да ја напуштите страницата?',
    pageNotFound: '404 - Страницата не е пронајдена',
    pageNotFoundDesc: 'Страницата што ја барате не постои.',
    backToDashboard: 'Назад кон контролната табла',
    characters: 'карактери',
    maxCharacters: 'Максимум {{max}} карактери',
    remaining: '{{count}} преостанати',
    selected: '{{count}} избрани',
    of_total: '{{count}} од {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Заглавие, странична лента, менија
  // ============================================================
  nav: {
    dashboard: 'Контролна табла',
    requests: 'Барања',
    transports: 'Транспорти',
    myPatients: 'Мои пациенти',
    statistics: 'Статистика',
    flow: 'Тек',
    resources: 'Resources',
    exercise: 'Вежба',
    administration: 'Администрација',
    map: 'Карта',
    info: 'Информации',
    users: 'Корисници',
    assets: 'Средства',
    hubs: 'Јазли',
    treatmentFacilities: 'Здравствени установи',
    patientImport: 'Увоз на пациенти',
    assetTemplates: 'Шаблони за средства',
    dayTemplates: 'Дневни шаблони',
    announcementTicker: 'Лента за известувања',
    exerciseStatistics: 'Статистика на вежба',
    settings: 'Поставки',
    auditLog: 'Дневник на ревизија',
    exerciseControl: 'Контрола на вежба',
    dataSync: 'Синхронизација на податоци',
    documentation: 'Документација',
    support: 'Поддршка',
    about: 'За системот',
    assetContracts: 'Asset Contracts',
    notifications: 'Известувања',
    schedules: 'Распоред',
    capacityPlanning: 'Планирање на капацитет',
    transportPlanning: 'Планирање на транспорт',
    transportBooking: 'Резервација на транспорт',
    flowDiagram: 'Дијаграм на тек',
    changePassword: 'Промена на лозинка',
    missions: 'Мисии',
    startPoints: 'Почетни точки',
    hospital: 'Болница',
  },

  // ============================================================
  // AUTH — Најава, лозинка, сесија
  // ============================================================
  auth: {
    login: 'Најава',
    logout: 'Одјава',
    logoutNow: 'Одјави се сега',
    loggingIn: 'Се најавувам...',
    loginFailed: 'Најавата не успеа',
    email: 'Е-пошта',
    password: 'Лозинка',
    username: 'Корисничко име',
    enterEmail: 'Внесете ја вашата е-пошта',
    enterPassword: 'Внесете ја вашата лозинка',
    enterUsername: 'Внесете го вашето корисничко име',
    forgotPassword: 'Заборавена лозинка?',
    forgotPasswordTitle: 'Заборавена лозинка',
    forgotPasswordDesc: 'Внесете го вашето корисничко име и е-пошта. Ако двете се совпаѓаат, администраторите ќе бидат известени да ја ресетираат вашата лозинка.',
    requestPasswordReset: 'Побарај ресетирање на лозинка',
    sending: 'Се испраќа...',
    backToLogin: 'Назад кон најава',
    pleaseWait: 'Ве молиме почекајте пред повторен обид.',
    requestFailed: 'Барањето не успеа',
    credentialsMatch: 'Ако податоците се совпаѓаат, администраторите се известени.',
    forAccess: 'За пристап, ве молиме контактирајте го администраторот на системот.',
    changePassword: 'Промена на лозинка',
    currentPassword: 'Тековна лозинка',
    newPassword: 'Нова лозинка',
    confirmPassword: 'Потврдете лозинка',
    passwordChanged: 'Лозинката е успешно променета',
    passwordMismatch: 'Лозинките не се совпаѓаат',
    passwordTooShort: 'Лозинката мора да има најмалку 8 карактери',
    changingPassword: 'Се менува...',
    mustChangePassword: 'Мора да ја промените лозинката пред да продолжите.',
    sessionExpiring: 'Сесијата истекува',
    sessionExpireText: 'Вашата сесија ќе истече за <strong>{{time}}</strong>. Ве молиме зачувајте ја вашата работа и најавете се повторно за да продолжите.',
    dismiss: 'Отфрли',
    switchNation: 'Промени нација',
    returnTo: 'Врати се на {{nation}}',
    viewingAs: 'Гледате како',
    loggedInAs: 'најавени како {{nation}}',
    trainingMode: 'САМО ЗА ПОТРЕБИ НА ОБУКА',
    dedication: 'Создадено со љубов и посветеност кон професијата',
  },

  // ============================================================
  // ROLES — Кориснички улоги и ознаки
  // ============================================================
  roles: {
    admin: 'Системски администратор',
    excon: 'Контролор на вежба',
    eu: 'ЕУ координатор',
    planner: 'Планер',
    hub: 'Менаџер на јазол',
    nation: 'Нација',
    readOnly: 'Само за читање',
    systemAdmin: 'Системски администратор',
    transportPlanner: 'Планер на транспорт',
    systemRoles: 'Системски улоги',
  },

  // ============================================================
  // STATUS — Статуси на барања, понуди, мисии
  // ============================================================
  status: {
    draft: 'Нацрт',
    underReview: 'На преглед',
    published: 'Објавено',
    underSelection: 'Во селекција',
    accepted: 'Прифатено',
    planned: 'Планирано',
    inTransit: 'Во транзит',
    completed: 'Завршено',
    closed: 'Затворено',
    withdrawn: 'Повлечено',
    pending: 'На чекање',
    rejected: 'Одбиено',
    cancelled: 'Откажано',
    active: 'Активно',
    inactive: 'Неактивно',
    review: 'Преглед',
    selection: 'Селекција',
    transit: 'Транзит',
  },

  // ============================================================
  // CATEGORIES — Категории на барања
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Персонал',
    material: 'Материјал',
    equipment: 'Опрема',
    other: 'Друго',
    news: 'Вести',
  },

  // ============================================================
  // URGENCY — Нивоа на итност
  // ============================================================
  urgency: {
    routine: 'Рутинско',
    priority: 'Приоритетно',
    urgent: 'Итно',
    immediate: 'Неодложно',
  },

  // ============================================================
  // ASSETS — Типови на транспортни средства
  // ============================================================
  assetTypes: {
    train: 'Воз',
    ship: 'Брод',
    aircraft: 'Авион',
    bus: 'Автобус',
    ambulance: 'Амбулантно возило',
    drone: 'Дрон',
    helicopter: 'Хеликоптер',
    ferry: 'Траект',
    other: 'Друго',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Контролна табла',
    goodMorning: 'Добро утро',
    goodAfternoon: 'Добар ден',
    goodEvening: 'Добра вечер',
    lastLogin: 'Последна најава',
    infrastructure: 'Инфраструктура',
    transportAssets: 'Транспортни средства',
    treatmentFacilities: 'Здравствени установи',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Статистика на барања',
    viewAllRequests: 'Прикажи сите барања',
    availableAssets: 'Достапни средства',
    seated: 'Седечки',
    lying: 'Лежечки',
    intensive: 'Интензивна нега',
    notifications: 'Известувања',
    markAllRead: 'Означи сите како прочитани',
    noNotifications: 'Нема известувања',
    notifiedWhenActivity: 'Ќе бидете известени кога ќе се појави нова активност',
    viewDetailsBtn: 'Прикажи детали',
    nationUsers: 'Корисници на нации',
    user: 'Корисник',
    roles: 'Улоги',
    noUsersFound: 'Не се пронајдени корисници',
    participatingNations: 'Учесници нации',
    exerciseDisclaimer: 'Овој систем е наменет исклучиво за вежба. Внесувајте само симулирани податоци за вежба. Работните процеси се прилагодени на сценариото на вежбата и може да се разликуваат од реалните процедури. Правилата за ИТ безбедност и заштита на податоци остануваат целосно применливи.',
    notConfigured: 'Не е конфигурирано',
    requestCount: '{{count}} барање(а)',
    clickToView: 'Кликнете за преглед',
    systemAdministration: 'Системска администрација',
    exerciseControlTitle: 'Контрола на вежба',
    euCoordination: 'ЕУ координација',
    transportPlanningTitle: 'Планирање на транспорт',
    hubManagement: 'Управување со јазли',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Ново барање',
    myDrafts: 'Мои нацрти',
    pendingReview: 'На чекање за преглед',
    activeTransports: 'Активни транспорти',
    myPatients: 'Мои пациенти',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Барања',
    newRequest: 'Ново барање',
    createRequest: 'Креирај барање',
    editRequest: 'Измени барање',
    requestDetail: 'Детали за барање',
    requestId: 'ID на барање',
    fromNation: 'Од нација',
    toNation: 'До нација',
    requestingNation: 'Нација што бара',
    receivingNation: 'Нација што прима',
    category: 'Категорија',
    urgency: 'Итност',
    status: 'Статус',
    patients: 'Пациенти',
    patientCount: 'Број на пациенти',
    offers: 'Понуди',
    offerCount: 'Број на понуди',
    created: 'Креирано',
    updated: 'Ажурирано',
    submittedBy: 'Поднесено од',
    reviewedBy: 'Прегледано од',
    description: 'Опис',
    medicalDetails: 'Медицински детали',
    transportDetails: 'Детали за транспорт',
    additionalInfo: 'Дополнителни информации',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Точка на поаѓање',
    arrivalPoint: 'Точка на пристигнување',
    estimatedDeparture: 'Проценето поаѓање',
    estimatedArrival: 'Проценето пристигнување',
    submitForReview: 'Поднеси за преглед',
    publish: 'Објави',
    startSelection: 'Започни селекција',
    acceptOffer: 'Прифати понуда',
    markInTransit: 'Означи како во транзит',
    markCompleted: 'Означи како завршено',
    closeRequest: 'Затвори барање',
    withdrawRequest: 'Повлечи барање',
    withdraw: 'Повлечи',
    revertToDraft: 'Врати на нацрт',
    deleteRequest: 'Избриши барање',
    duplicateRequest: 'Дуплирај барање',
    createFollowUp: 'Креирај консолидирано барање',
    followUpRequest: 'Консолидирано барање',
    parentRequest: 'Оригинално барање',
    childRequests: 'Консолидирани барања',
    noRequests: 'Не се пронајдени барања',
    noOffers: 'Нема понуди',
    addPatient: 'Додај пациент',
    removePatient: 'Отстрани пациент',
    patientDetails: 'Детали за пациент',
    contactPerson: 'Контакт лице',
    contactPhone: 'Контакт телефон',
    contactEmail: 'Контакт е-пошта',
    specialRequirements: 'Посебни барања',
    medicalEquipment: 'Медицинска опрема',
    accompaniment: 'Придружба',
    timeline: 'Хронологија',
    history: 'Историја',
    addComment: 'Додај коментар',
    writeComment: 'Напишете коментар...',
    postComment: 'Објави коментар',
    posting: 'Се објавува...',
    noComments: 'Нема коментари',
    coverageBar: 'Покриеност',
    covered: 'покриено',
    uncovered: 'непокриено',
    filterByStatus: 'Филтрирај по статус',
    filterByCategory: 'Филтрирај по категорија',
    filterByNation: 'Филтрирај по нација',
    searchRequests: 'Пребарај барања...',
    confirmWithdraw: 'Дали сте сигурни дека сакате да го повлечете ова барање?',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете ова барање?',
    confirmPublish: 'Дали сте сигурни дека сакате да го објавите ова барање? Ќе биде видливо за сите нации.',
    confirmStartSelection: 'Дали сте сигурни дека сакате да започнете селекција? Нациите ќе можат да даваат понуди.',
    warningStartSelection: 'Започнувањето на селекцијата ќе го направи ова барање видливо за сите учесници нации. Тие ќе можат да поднесат понуди за пациентите во ова барање. Ова дејство не може да се поништи.',
    warningMakeOffer: 'Со поднесување на оваа понуда, ја обврзувате вашата нација да ја обезбеди предложената помош. Ова дејство ќе ја извести нацијата што бара и контролата на вежбата.',
    saveDraft: 'Зачувај нацрт',
    saving: 'Се зачувува...',
    saveAndSubmit: 'Зачувај и поднеси',
    step: 'Чекор {{number}}',
    generalInfo: 'Општи информации',
    patientInfo: 'Информации за пациент',
    logisticsInfo: 'Логистички информации',
    reviewSubmit: 'Преглед и поднесување',
    requestTitle: 'Наслов на барање',
    requestDescription: 'Опис на барање',
    numberOfPatients: 'Број на пациенти',
    typeOfAssistance: 'Вид на помош',
    medicalTreatment: 'Медицински третман',
    transportAssistance: 'Транспортна помош',
    both: 'Двете',
    treatmentOnly: 'Само третман',
    transportOnly: 'Само транспорт',
    validationErrors: 'Ве молиме исправете ги следните грешки:',
    fieldRequired: 'Ова поле е задолжително',
    selectExitHub: 'Изберете излезен јазол',
    createExitHub: 'Креирај излезен јазол',
    backToRequests: 'Назад кон барања',
    noRequestsFound: 'Не се пронајдени барања',
    createFirstRequest: 'Креирајте го вашето прво барање за да започнете',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Понуди',
    createOffer: 'Креирај понуда',
    makeOffer: 'Дај понуда',
    manageOffers: 'Управувај со понуди',
    offerDetail: 'Детали за понуда',
    offerId: 'ID на понуда',
    offeringNation: 'Нација што нуди',
    offerType: 'Тип на понуда',
    treatment: 'Третман',
    transport: 'Транспорт',
    combined: 'Комбинирано',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Понуда за третман',
    transportOffer: 'Понуда за транспорт',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Изберете пациенти',
    selectedPatients: 'Избрани пациенти',
    patientSelection: 'Избор на пациенти',
    offerConfiguration: 'Конфигурација на понуда',
    reviewOffer: 'Преглед на понуда',
    submitOffer: 'Поднеси понуда',
    submitting: 'Се поднесува...',
    acceptOffer: 'Прифати понуда',
    rejectOffer: 'Одбиј понуда',
    withdrawOffer: 'Повлечи понуда',
    noOffers: 'Нема достапни понуди',
    noOffer: 'No Offer',
    offerStatus: 'Статус на понуда',
    offerDate: 'Датум на понуда',
    transportAsset: 'Транспортно средство',
    departureDate: 'Датум на поаѓање',
    arrivalDate: 'Датум на пристигнување',
    treatmentFacility: 'Здравствена установа',
    capacity: 'Капацитет',
    availableCapacity: 'Достапен капацитет',
    totalCapacity: 'Вкупен капацитет',
    selectAsset: 'Изберете средство',
    selectFacility: 'Изберете установа',
    offerNotes: 'Белешки за понуда',
    confirmAccept: 'Дали сте сигурни дека сакате да ја прифатите оваа понуда?',
    confirmReject: 'Дали сте сигурни дека сакате да ја одбиете оваа понуда?',
    extendTransport: 'Продолжен транспорт',
    transportExtension: 'Продолжување на транспорт',
    comparisonView: 'Споредбен преглед',
    shortlist: 'Тесен избор',
    addToShortlist: 'Додај во тесен избор',
    removeFromShortlist: 'Отстрани од тесен избор',
    leaveConfirmTitle: 'Напуштате страница?',
    leaveConfirmMessage: 'Имате незачувани промени. Дали сте сигурни дека сакате да ја напуштите страницата?',
    stayOnPage: 'Остани на страница',
    leavePage: 'Напушти страница',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Транспорти',
    missionDetail: 'Детали за транспорт',
    missionId: 'ID на транспорт',
    missionStatus: 'Статус на транспорт',
    createMission: 'Креирај транспорт',
    overview: 'Преглед',
    patientsTab: 'Пациенти',
    transportsTab: 'Транспортни делници',
    treatmentTab: 'Третман',
    reviewTab: 'Преглед',
    departure: 'Поаѓање',
    arrival: 'Пристигнување',
    origin: 'Почеток',
    destination: 'Дестинација',
    stops: 'Станици',
    addStop: 'Додај станица',
    removeStop: 'Отстрани станица',
    stopName: 'Име на станица',
    stopType: 'Тип на станица',
    estimatedTime: 'Проценето време',
    actualTime: 'Вистинско време',
    asset: 'Средство',
    driver: 'Возач',
    crew: 'Екипаж',
    noMissions: 'Не се пронајдени транспорти',
    completeMission: 'Заврши транспорт',
    cancelMission: 'Откажи транспорт',
    startTransport: 'Започни транспорт',
    missionChain: 'Синџир на транспорт',
    linkedMissions: 'Поврзани транспорти',
    handover: 'Примопредавање',
    handoverPoint: 'Точка на примопредавање',
    pickupPoint: 'Точка на преземање',
    dropoffPoint: 'Точка на истовар',
    searchTransports: 'Пребарај транспорти...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Пациенти',
    myPatients: 'Мои пациенти',
    patientId: 'ID на пациент',
    firstName: 'Име',
    lastName: 'Презиме',
    dateOfBirth: 'Датум на раѓање',
    age: 'Возраст',
    gender: 'Пол',
    male: 'Машки',
    female: 'Женски',
    other: 'Друго',
    nationality: 'Државјанство',
    diagnosis: 'Дијагноза',
    condition: 'Состојба',
    stable: 'Стабилна',
    critical: 'Критична',
    serious: 'Сериозна',
    treatmentNeeded: 'Потребен третман',
    allergies: 'Алергии',
    medications: 'Лекови',
    bloodType: 'Крвна група',
    weight: 'Тежина (кг)',
    infectious: 'Заразно',
    mentalHealth: 'Ментално здравје',
    mobility: 'Подвижност',
    ambulatory: 'Подвижен',
    wheelchair: 'Инвалидска количка',
    stretcher: 'Носилка',
    intensive: 'Интензивна нега',
    oxygenRequired: 'Потребен кислород',
    ventilator: 'Вентилатор',
    medicalEscort: 'Медицинска придружба',
    noPatients: 'Не се пронајдени пациенти',
    patientDetails: 'Детали за пациент',
    medicalHistory: 'Медицинска историја',
    travelDocuments: 'Патни документи',
    passport: 'Пасош',
    pseudonymizedId: 'Псевдонимизиран ID',
    sensitiveData: 'Чувствителни податоци',
    journey: 'Патека на пациент',
    assignedTo: 'Доделен на',
    currentLocation: 'Тековна локација',
    importPatients: 'Увези пациенти',
    exportPatients: 'Извези пациенти',
    seated: 'Седечки',
    lying: 'Лежечки',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Корисници',
    createUser: 'Креирај корисник',
    editUser: 'Измени корисник',
    deleteUser: 'Избриши корисник',
    username: 'Корисничко име',
    displayName: 'Прикажано име',
    email: 'Е-пошта',
    password: 'Лозинка',
    role: 'Улога',
    roles: 'Улоги',
    nation: 'Нација',
    active: 'Активен',
    lastLogin: 'Последна најава',
    createdAt: 'Креирано',
    isNation: 'Нација',
    isEU: 'ЕУ',
    isAdmin: 'Администратор',
    isExcon: 'EXCON',
    isPlanner: 'Планер',
    isHub: 'Јазол',
    isReadOnly: 'Само за читање',
    noUsers: 'Не се пронајдени корисници',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете овој корисник?',
    resetPassword: 'Ресетирај лозинка',
    generatePassword: 'Генерирај лозинка',
    searchUsers: 'Пребарај корисници...',
    userCreated: 'Корисникот е успешно креиран',
    userUpdated: 'Корисникот е успешно ажуриран',
    userDeleted: 'Корисникот е успешно избришан',
    selectNation: 'Изберете нација',
    mustChangePassword: 'Мора да ја промени лозинката при следна најава',
    flagImage: 'Слика на знаме',
    exportUsers: 'Извези корисници',
    importUsers: 'Увези корисници',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Средства',
    createAsset: 'Креирај средство',
    editAsset: 'Измени средство',
    deleteAsset: 'Избриши средство',
    assetName: 'Име на средство',
    assetType: 'Тип на средство',
    capacitySeated: 'Капацитет (седечки)',
    capacityLying: 'Капацитет (лежечки)',
    capacityIntensive: 'Капацитет (интензивна нега)',
    owner: 'Сопственик',
    operator: 'Оператор',
    baseLocation: 'Базна локација',
    range: 'Дострел',
    speed: 'Брзина',
    noAssets: 'Не се пронајдени средства',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете ова средство?',
    searchAssets: 'Пребарај средства...',
    assetCreated: 'Средството е успешно креирано',
    assetUpdated: 'Средството е успешно ажурирано',
    assetDeleted: 'Средството е успешно избришано',
    exportAssets: 'Извези средства',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Јазли',
    startPoints: 'Почетни точки',
    createHub: 'Креирај јазол',
    editHub: 'Измени јазол',
    deleteHub: 'Избриши јазол',
    hubName: 'Име на јазол',
    hubType: 'Тип на јазол',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Влезен јазол',
    airport: 'Аеродром',
    seaport: 'Пристаниште',
    railStation: 'Железничка станица',
    roadPoint: 'Патна точка',
    ucpmClassification: 'UCPM класификација',
    icaoCode: 'ICAO код',
    iataCode: 'IATA код',
    noHubs: 'Не се пронајдени јазли',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете овој јазол?',
    searchHubs: 'Пребарај јазли...',
    nationAssignment: 'Доделување на нации',
    assignNations: 'Додели нации',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Здравствени установи',
    createFacility: 'Креирај установа',
    editFacility: 'Измени установа',
    deleteFacility: 'Избриши установа',
    facilityName: 'Име на установа',
    facilityType: 'Тип на установа',
    hospitalName: 'Име на болница',
    bedCapacity: 'Капацитет на легла',
    specialties: 'Специјалности',
    availableBeds: 'Достапни легла',
    totalBeds: 'Вкупно легла',
    contactPerson: 'Контакт лице',
    noFacilities: 'Не се пронајдени здравствени установи',
    confirmDelete: 'Дали сте сигурни дека сакате да ја избришете оваа установа?',
    searchFacilities: 'Пребарај установи...',
    hubNationAssignment: 'Доделување на нации на јазол',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Распоред',
    createSchedule: 'Креирај распоред',
    editSchedule: 'Измени распоред',
    deleteSchedule: 'Избриши распоред',
    scheduleName: 'Име на распоред',
    scheduleType: 'Тип на распоред',
    recurring: 'Повторлив',
    oneTime: 'Еднократен',
    frequency: 'Фреквенција',
    daily: 'Дневно',
    weekly: 'Неделно',
    startDate: 'Датум на почеток',
    endDate: 'Датум на завршување',
    departureTime: 'Време на поаѓање',
    arrivalTime: 'Време на пристигнување',
    stops: 'Станици',
    addStop: 'Додај станица',
    noSchedules: 'Не се пронајдени распореди',
    bookings: 'Резервации',
    timeline: 'Хронологија',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Известувања',
    markAllRead: 'Означи сите како прочитани',
    markAsRead: 'Означи како прочитано',
    markAsUnread: 'Означи како непрочитано',
    noNotifications: 'Нема известувања',
    viewAll: 'Прикажи сите известувања',
    settings: 'Поставки за известувања',
    emailNotifications: 'Известувања преку е-пошта',
    inAppNotifications: 'Известувања во апликација',
    notifyOn: 'Извести ме за',
    requestCreated: 'Ново барање',
    requestPublished: 'Барање објавено',
    requestClosed: 'Барање затворено',
    requestCompleted: 'Барање завршено',
    commentAdded: 'Нов коментар',
    offerReceived: 'Понуда примена',
    offerAccepted: 'Понуда прифатена',
    statusChanged: 'Статус променет',
    selectionStarted: 'Селекција започната',
    missionCreated: 'Транспорт креиран',
    missionStatusUpdated: 'Транспорт ажуриран',
    transportPartnerNamed: 'Транспортен партнер',
    transportExtensionReceived: 'Продолжување на транспорт',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Поставки',
    general: 'Општо',
    system: 'Систем',
    email: 'Е-пошта',
    sync: 'Синхронизација',
    security: 'Безбедност',
    appearance: 'Изглед',
    systemName: 'Име на систем',
    systemEmail: 'Е-пошта на систем',
    maintenanceMode: 'Режим на одржување',
    readOnlyMode: 'Режим само за читање',
    emailEnabled: 'Е-пошта овозможена',
    smtpHost: 'SMTP сервер',
    smtpPort: 'SMTP порт',
    smtpUser: 'SMTP корисник',
    smtpPassword: 'SMTP лозинка',
    senderEmail: 'Е-пошта на испраќач',
    senderName: 'Име на испраќач',
    testEmail: 'Испрати тест е-пошта',
    syncEnabled: 'Синхронизација овозможена',
    syncUrl: 'URL за синхронизација',
    syncApiKey: 'API клуч за синхронизација',
    settingsSaved: 'Поставките се успешно зачувани',
    helpdesk: 'Поддршка',
    helpdeskTitle: 'Наслов на поддршка',
    helpdeskEmail: 'Е-пошта на поддршка',
    helpdeskPhone: 'Телефон на поддршка',
    helpdeskInfo: 'Информации за поддршка',
    realLifeSupport: 'Поддршка во реален живот',
    trainingMode: 'Режим на обука',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Дневник на ревизија',
    action: 'Дејство',
    user: 'Корисник',
    target: 'Цел',
    details: 'Детали',
    timestamp: 'Временски печат',
    ipAddress: 'IP адреса',
    noLogs: 'Не се пронајдени записи во дневникот',
    searchLogs: 'Пребарај записи...',
    filterByAction: 'Филтрирај по дејство',
    filterByUser: 'Филтрирај по корисник',
    exportLogs: 'Извези записи',
    exportCsv: 'Извези CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Контрола на вежба',
    currentDay: 'Тековен ден',
    exerciseDay: 'Ден на вежба',
    nextDay: 'Следен ден',
    previousDay: 'Претходен ден',
    resetExercise: 'Ресетирај вежба',
    startExercise: 'Започни вежба',
    endExercise: 'Заврши вежба',
    dayReset: 'Ресетирање на ден',
    confirmReset: 'Дали сте сигурни дека сакате да го ресетирате денот на вежба? Ова ќе ги избрише сите податоци за тековниот ден.',
    resetInProgress: 'Ресетирање во тек...',
    maintenanceMode: 'Режим на одржување',
    enableMaintenance: 'Овозможи одржување',
    disableMaintenance: 'Оневозможи одржување',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Синхронизација на податоци',
    syncStatus: 'Статус на синхронизација',
    lastSync: 'Последна синхронизација',
    pendingItems: 'Ставки на чекање',
    syncNow: 'Синхронизирај сега',
    syncing: 'Синхронизација...',
    syncSuccess: 'Синхронизацијата е успешно завршена',
    syncFailed: 'Синхронизацијата не успеа',
    outbox: 'Излезно сандаче',
    inbox: 'Влезно сандаче',
    configuration: 'Конфигурација',
    targetUrl: 'Целен URL',
    apiKey: 'API клуч',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Карта',
    layers: 'Слоеви',
    requests: 'Барања',
    hubs: 'Јазли',
    facilities: 'Установи',
    routes: 'Рути',
    showAll: 'Прикажи сите',
    hideAll: 'Скриј сите',
    zoomIn: 'Зголеми',
    zoomOut: 'Намали',
    resetView: 'Ресетирај приказ',
    satellite: 'Сателитски',
    terrain: 'Терен',
    offline: 'Офлајн',
    online: 'Онлајн',
    tilesOffline: 'Картографските плочки се вчитуваат локално',
    tilesOnline: 'Картографските плочки се вчитуваат од онлајн сервери',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Статистика',
    overview: 'Преглед',
    requestsByStatus: 'Барања по статус',
    requestsByCategory: 'Барања по категорија',
    requestsByNation: 'Барања по нација',
    offersByStatus: 'Понуди по статус',
    patientsByCondition: 'Пациенти по состојба',
    transportsByStatus: 'Транспорти по статус',
    timeline: 'Хронологија',
    totalRequests: 'Вкупно барања',
    totalOffers: 'Вкупно понуди',
    totalPatients: 'Вкупно пациенти',
    totalTransports: 'Вкупно транспорти',
    averageResponseTime: 'Просечно време на одговор',
    completionRate: 'Стапка на завршеност',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Статистика на вежба',
    overview: 'Преглед',
    byCategory: 'По категорија',
    byNation: 'По нација',
    byDay: 'По ден',
    totalPatientsMoved: 'Вкупно преместени пациенти',
    totalRequestsProcessed: 'Вкупно обработени барања',
    averageProcessingTime: 'Просечно време на обработка',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Дијаграм на тек',
    sankey: 'Санки',
    nodeGraph: 'Граф на јазли',
    refresh: 'Освежи',
    noData: 'Нема достапни податоци за тек',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'За системот',
    version: 'Верзија',
    systemInfo: 'Системски информации',
    buildDate: 'Датум на изградба',
    environment: 'Опкружување',
    description: 'ARCOS — Напреден систем за комуникација на барања',
    subtitle: 'Помош за жртви и медицински операции',
    whatIsArcos: 'Што е ARCOS? – Објаснување за учесниците во вежбата',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Поддржано од MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – каде љубопитноста ја среќава соработката.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Документација',
    gettingStarted: 'Почетни чекори',
    userGuide: 'Корисничко упатство',
    faq: 'Чести прашања',
    troubleshooting: 'Решавање проблеми',
    apiReference: 'API референца',
    downloadTemplate: 'Преземи шаблон',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Увоз на пациенти',
    uploadFile: 'Отпреми датотека',
    selectFile: 'Избери датотека',
    preview: 'Преглед',
    importNow: 'Увези сега',
    importing: 'Увоз во тек...',
    importSuccess: '{{count}} пациенти успешно увезени',
    importFailed: 'Увозот не успеа',
    downloadTemplate: 'Преземи шаблон',
    dragDrop: 'Повлечете и пуштете датотека овде, или кликнете за да изберете',
    supportedFormats: 'Поддржани формати: XLSX, XLS, CSV',
    rowsFound: '{{count}} редови пронајдени',
    validRows: '{{count}} валидни редови',
    invalidRows: '{{count}} невалидни редови',
    duplicateRows: '{{count}} дуплирани редови',
    previewData: 'Преглед на податоци',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Планирање на транспорт',
    planRoute: 'Планирај рута',
    routeBuilder: 'Креатор на рута',
    addWaypoint: 'Додај патна точка',
    removeWaypoint: 'Отстрани патна точка',
    estimatedDuration: 'Проценето траење',
    distance: 'Растојание',
    selectVehicle: 'Изберете возило',
  },

  transportBooking: {
    title: 'Резервација на транспорт',
    bookTransport: 'Резервирај транспорт',
    availableSlots: 'Достапни термини',
    bookingConfirmed: 'Резервацијата е потврдена',
    cancelBooking: 'Откажи резервација',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Планирање на капацитет',
    totalCapacity: 'Вкупен капацитет',
    usedCapacity: 'Искористен капацитет',
    availableCapacity: 'Достапен капацитет',
    utilizationRate: 'Стапка на искористеност',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Шаблони за средства',
    dayTemplates: 'Дневни шаблони',
    createTemplate: 'Креирај шаблон',
    editTemplate: 'Измени шаблон',
    deleteTemplate: 'Избриши шаблон',
    templateName: 'Име на шаблон',
    applyTemplate: 'Примени шаблон',
    noTemplates: 'Не се пронајдени шаблони',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете овој шаблон?',
    confirmApply: 'Дали сте сигурни дека сакате да го примените овој шаблон? Ова ќе ги препише постоечките податоци.',
    exportTemplates: 'Извези шаблони',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Лента за известувања',
    createAnnouncement: 'Креирај известување',
    editAnnouncement: 'Измени известување',
    deleteAnnouncement: 'Избриши известување',
    message: 'Порака',
    startTime: 'Време на почеток',
    endTime: 'Време на завршување',
    active: 'Активно',
    noAnnouncements: 'Нема известувања',
    confirmDelete: 'Дали сте сигурни дека сакате да го избришете ова известување?',
  },

  // ============================================================
  // COMPONENTS — Стрингови за компоненти за повеќекратна употреба
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Пребарај...',
      noResults: 'Нема пронајдени резултати',
      showing: 'Прикажано {{from}} до {{to}} од {{total}}',
      rowsPerPage: 'Редови по страница',
      previousPage: 'Претходна страница',
      nextPage: 'Следна страница',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Потврди',
      cancel: 'Откажи',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Незачувани промени',
      message: 'Имате незачувани промени. Дали сте сигурни дека сакате да ја напуштите оваа страница?',
      stay: 'Остани на страница',
      leave: 'Напушти страница',
    },
    // EmptyState
    emptyState: {
      noData: 'Нема достапни податоци',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Нешто тргна наопаку',
      message: 'Настана неочекувана грешка. Ве молиме обидете се да ја освежите страницата.',
      retry: 'Обиди се повторно',
    },
    // ExportButton
    exportButton: {
      export: 'Извези',
      exporting: 'Извезување...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Печати',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Нацрт',
      review: 'Преглед',
      published: 'Објавено',
      selection: 'Селекција',
      inTransit: 'Во транзит',
      completed: 'Завршено',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Онлајн инстанца',
      message: 'Режим само за читање. Податоците се синхронизираат од примарниот сервер.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Гледате како',
      loggedInAs: 'најавени како {{nation}}',
      returnTo: 'Врати се на {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Пребарај страници, барања, транспорти...',
      searching: 'Пребарување...',
      noResults: 'Нема резултати за "{{query}}"',
      navigate: 'Навигација',
      select: 'Избери',
      close: 'Затвори',
      pages: {
        dashboard: 'Контролна табла',
        requests: 'Барања',
        transports: 'Транспорти',
        map: 'Карта',
        myPatients: 'Мои пациенти',
        flowDiagram: 'Дијаграм на тек',
        statistics: 'Статистика',
        assets: 'Средства',
        startPoints: 'Почетни точки / Јазли',
        treatmentFacilities: 'Здравствени установи',
        users: 'Корисници',
        settings: 'Поставки',
        auditLogs: 'Дневник на ревизија',
        exerciseControl: 'Контрола на вежба',
        dataSync: 'Синхронизација на податоци',
        patientImport: 'Увоз на пациенти',
        notifications: 'Известувања',
        documentation: 'Документација',
      },
      actions: {
        importPatientsJson: 'Увези Пациенти (JSON)',
        importPatientsExcel: 'Увези Пациенти (Excel)',
        importUsers: 'Увези Корисници (Excel)',
        importAssetTemplates: 'Увези Шаблони за средства (Excel)',
        importDayTemplates: 'Увези Записи за дневен шаблон (Excel)',
        exportRequests: 'Извези Барања (Excel)',
        exportPatients: 'Извези Пациенти (Excel)',
        exportUsers: 'Извези Корисници (Excel)',
        exportCredentials: 'Извези Акредитиви (PDF)',
        exportAuditExcel: 'Извези Ревизорски дневник (Excel)',
        exportAuditPdf: 'Извези Ревизорски дневник (PDF)',
        pagePatientImport: 'Страница за увоз на пациенти',
        pageRequestDetail: 'Страница за детали на барање',
        pageUsers: 'Страница за управување со корисници',
        pageAssetTemplates: 'Страница за шаблони за средства',
        pageDayTemplates: 'Страница за дневни шаблони',
        pageRequests: 'Страница за листа на барања',
        pageAuditLogs: 'Страница за ревизорски дневник',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Сесијата истекува',
      message: 'Вашата сесија ќе истече за <strong>{{time}}</strong>. Ве молиме зачувајте ја вашата работа и најавете се повторно за да продолжите.',
      dismiss: 'Отфрли',
      logoutNow: 'Одјави се сега',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Изберете 4 временски зони',
      configure: 'Конфигурирајте временски зони',
      reset: 'Ресетирај',
      apply: 'Примени',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Изберете локација',
      latitude: 'Географска ширина',
      longitude: 'Географска должина',
      clickToSelect: 'Кликнете на картата за да изберете локација',
    },
    // Modal
    modal: {
      close: 'Затвори',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Почетна',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Одржување на систем',
    message: 'Системот се ресетира за следниот ден на вежба. Ве молиме почекајте додека процесот не заврши.',
    autoRefresh: 'Оваа страница автоматски ќе се освежи кога системот ќе биде повторно достапен.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Најмалку 10 знаци',
    uppercase: '1 голема буква',
    lowercase: '1 мала буква',
    digit: '1 цифра',
    special: '1 специјален знак',
  },
};

export default mk;
